import React, { Fragment } from 'react'
import Table from 'UI/Table'
import ActionColumn from 'UI/Table/components/ActionColumn'
import EditableColumn from 'UI/Table/components/EditableColumn'

class SitesTable extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      sites: props.sites,
      loading: false,
      fields: {
        id: null,
        code: null,
        name: null,
        location_id: null,
        site_type: null,
        lifecycle_status: null,
        location: null
      }
    }
  }

  updateState = newState => this.setState(newState)

  render () {
    const { locations, site_types, lifecycle_statuses } = this.props
    const { sites, loading, fields } = this.state
    const { updateState } = this
    const columns = [
      {
        Header: '',
        maxWidth: 80,
        style: { textAlign: 'center' },
        filterable: false,
        Cell: (row) => (
          <ActionColumn {...{ row, fields, updateState, url: '/system/sites', options: sites, arrayName: 'sites' }} />
        ),
      },
      { Header: 'Code', accessor: 'code', Cell: row => <EditableColumn {...{ row, type: 'text', fields, updateState }} /> },
      { Header: 'Name', accessor: 'name', Cell: row => <EditableColumn {...{ row, type: 'text', fields, updateState }} /> },
      { Header: 'Location', accessor: 'location', Cell: row => <EditableColumn {...{ row, type: 'select', fieldName: 'location_id', fields, updateState, options: locations }} /> },
      { Header: 'Site Type', accessor: 'site_type', Cell: row => <EditableColumn {...{ row, type: 'select', fields, updateState, options: site_types }} /> },
      { Header: 'Lifecycle Status', accessor: 'lifecycle_status', Cell: row => <EditableColumn {...{ row, type: 'select', fields, updateState, options: lifecycle_statuses }} /> },
    ]

    return (
      <Table {...{ data: sites, columns, loading }} filterable />
    )
  }
}

export default SitesTable
